import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
const salesPersonUri = config.apiEndpoints.salesPersonUri
export default {
    findAll: (keywords, page) => {
        return new Promise((resolve, reject) => {            
            HTTP.get(`${salesPersonUri}search?keywords=${keywords}&pageSize=${pageSize}&page=${page}` ).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (keywords, level) => {
        return new Promise((resolve, reject) => {
            HTTP.get(salesPersonUri.concat(`?keywords=${keywords}&level=${level}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },    
    find: (salesPersonId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(salesPersonUri.concat(salesPersonId)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findDetailed: (salesPersonId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(salesPersonUri.concat(`${salesPersonId}/details`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    createSalesPerson: (request) => {
        return new Promise((resolve, reject) => {
            HTTP.post(salesPersonUri, request).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    updateSalesPerson: (request) => {
        return new Promise((resolve, reject) => {
            HTTP.put(salesPersonUri, request).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}